{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Krāsu atlasītājs",
  "twoDimensionalSlider": "2D slīdnis",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
